import { ActivityDataSourceIncludeEmissionFactors, ActivityDataSourceWithChildrenInclude, } from './ActivityDataSource';
import { CalculationMethodInclude } from './CalculationMethod';
export var FindOneLogWithLogEntryInclude = function (emissionFactor) { return ({
    inputs: { where: { deletedAt: null }, include: { unit: true } },
    subcategory: true,
    activityDataSource: { include: ActivityDataSourceIncludeEmissionFactors(emissionFactor) },
    calculationMethod: { include: CalculationMethodInclude },
    supplier: true,
    customer: true,
    tags: {
        include: {
            tag: true,
        },
    },
    territory: true,
}); };
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export var LogEntryInclude = function (lean) {
    if (lean === void 0) { lean = false; }
    return ({
        inputs: {
            where: { deletedAt: null },
            include: {
                unit: { include: { conversionFactorDestinations: true } },
            },
        },
        customer: true,
        subcategory: true,
        activityDataSource: {
            include: ActivityDataSourceWithChildrenInclude({
                emissionFactor: true,
                lean: lean,
            }),
        },
        organizationEmissions: {
            where: { deletedAt: null },
            include: {
                factor: true,
            },
        },
        calculationMethod: { include: CalculationMethodInclude },
        log: {
            include: {
                owner: true,
                category: true,
                location: { include: { organization: true, businessUnit: true } },
                organizationEmissions: { where: { deletedAt: null } },
            },
        },
        supplier: true,
        tags: {
            include: {
                tag: true,
            },
        },
        territory: { include: { continent: true } },
    });
};
//# sourceMappingURL=LogEntry.js.map